import { useCompanySettings } from './useCompanySettings';

export function useLogo(context = 'auto') {
  const { logo, logoDark } = useCompanySettings();
  
  // Detecta se o tema dark está ativo
  const isDarkMode = document.documentElement.classList.contains('dark');
  
  let currentLogo;
  
  switch (context) {
    case 'navbar':
      // Para navbar: usa logoDark com fallback para logo
      currentLogo = logoDark || logo;
      break;
    case 'footer':
      // Para footer: usa logo (light) com fallback para logoDark
      currentLogo = logo || logoDark;
      break;
    case 'dark':
      // Força uso da logo dark
      currentLogo = logoDark || logo;
      break;
    case 'light':
      // Força uso da logo light
      currentLogo = logo || logoDark;
      break;
    default:
      // Modo automático baseado no tema
      currentLogo = isDarkMode ? (logoDark || logo) : (logo || logoDark);
  }
  
  return {
    logo: currentLogo,
    logoLight: logo,
    logoDark: logoDark,
    isDarkMode
  };
}
